var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmpty = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12318_166146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 29.8561H3.33333C1.496 29.8561 0 28.3615 0 26.5228V17.1895C0 17.0961 0.02 17.0015 0.0586667 16.9161L5.35067 5.15612C5.88933 3.96145 7.08267 3.18945 8.39067 3.18945H23.6093C24.9173 3.18945 26.1107 3.96145 26.6493 5.15612L31.9413 16.9161C31.98 17.0015 32 17.0961 32 17.1895V26.5228C32 28.3615 30.504 29.8561 28.6667 29.8561ZM1.33333 17.3321V26.5228C1.33333 27.6255 2.23067 28.5228 3.33333 28.5228H28.6667C29.7693 28.5228 30.6667 27.6255 30.6667 26.5228V17.3321L25.4333 5.70145C25.1107 4.98679 24.3947 4.52279 23.6093 4.52279H8.39067C7.60533 4.52279 6.88933 4.98679 6.56667 5.70279L1.33333 17.3321Z",
    fill: "#255E8E",
    stroke: "#255E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.408 23.1891H9.58936C8.76003 23.1891 8.00803 22.6678 7.71736 21.8918L6.36536 18.2878C6.26936 18.0291 6.0187 17.8558 5.74136 17.8558H0.998698C0.630698 17.8558 0.332031 17.5571 0.332031 17.1891C0.332031 16.8211 0.630698 16.5225 0.998698 16.5225H5.74136C6.5707 16.5225 7.3227 17.0438 7.6147 17.8198L8.96536 21.4238C9.0627 21.6825 9.31336 21.8558 9.58936 21.8558H22.4067C22.684 21.8558 22.9347 21.6825 23.0307 21.4238L24.3814 17.8198C24.6747 17.0438 25.4267 16.5225 26.256 16.5225H31.332C31.7 16.5225 31.9987 16.8211 31.9987 17.1891C31.9987 17.5571 31.7 17.8558 31.332 17.8558H26.256C25.9787 17.8558 25.728 18.0291 25.632 18.2878L24.2814 21.8918C23.9894 22.6678 23.236 23.1891 22.408 23.1891Z",
    fill: "#255E8E",
    stroke: "#255E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12318_166146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.522461)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty.ae36f988.svg";
export { ForwardRef as ReactComponent };